import { render, staticRenderFns } from "./suggest.vue?vue&type=template&id=75b928da&scoped=true&"
import script from "./suggest.vue?vue&type=script&lang=js&"
export * from "./suggest.vue?vue&type=script&lang=js&"
import style0 from "./suggest.vue?vue&type=style&index=0&id=75b928da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b928da",
  null
  
)

export default component.exports